import { render } from "./UnderwearView.vue?vue&type=template&id=5aca965b&scoped=true"
import script from "./UnderwearView.vue?vue&type=script&lang=js"
export * from "./UnderwearView.vue?vue&type=script&lang=js"

import "./UnderwearView.vue?vue&type=style&index=0&id=5aca965b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aca965b"]])

export default __exports__